import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowGraphics } from './ArrowGraphics';
const MenuItemGraphics = ({ name, index, open, active, }) => {
    return (_jsxs("div", { style: {
            transitionDelay: open
                ? `calc(${index * 0.1}s + (var(--animTimeIn) * 0.22))`
                : '0s',
            opacity: open ? 1 : 0,
        }, className: `menu-item-graphics${open ? ' open' : ''}${active ? ' active' : ''}`, children: [_jsx("div", { className: "menu-item-wrapper", children: name }), _jsx(ArrowGraphics, {})] }, name));
};
export default MenuItemGraphics;
